const reportWebVitals = (onPerfEntry) => {
  if (onPerfEntry && typeof onPerfEntry === 'function') {
    import('web-vitals')
      .then((vitals) => {
        const { getCLS, getFID, getFCP, getLCP, getTTFB } = vitals;
        if (getCLS) {
          getCLS(onPerfEntry);
        }
        if (getFID) {
          getFID(onPerfEntry);
        }
        if (getFCP) {
          getFCP(onPerfEntry);
        }
        if (getLCP) {
          getLCP(onPerfEntry);
        }
        if (getTTFB) {
          getTTFB(onPerfEntry);
        }
      })
      .catch((error) => {
        console.error('Failed to load web-vitals:', error);
      });
  }
};

export default reportWebVitals;
